<script lang="ts" setup>
import type { PropType } from "vue"
import type { ICustomSocialLinks } from "./footer.interface"
import type { IconKeys } from "@/components/ui/Icon/Icon.interface"
import { computed } from "vue"
import { Icon } from "@/components/ui"
import { getBrandSocialLinks } from "./footer.constants"

const props = defineProps({
  customSocial: {
    type: Object as PropType<ICustomSocialLinks | null>,
    default: null,
  },
  isTemplate: {
    type: Boolean,
    default: false,
  },
})

const defaultGpxSocialLinks = getBrandSocialLinks()

const socialIconMap: Record<string, IconKeys> = {
  instagram: "Instagram",
  facebook: "Facebook",
  pinterest: "Pinterest",
  tiktok: "TikTok",
  youtube: "YouTube",
  linkedIn: "LinkedIn",
  x: "X",
}

const hasCustomLinks = computed(() =>
  props.customSocial && Object.values(props.customSocial).some(link => !!link),
)

const socialLinks = computed(() => {
  if (hasCustomLinks.value && props.customSocial) {
    return Object.fromEntries(Object.entries(props.customSocial).filter(([_, value]) => !!value))
  }
  return defaultGpxSocialLinks
})
</script>

<template>
  <ul class="flex gap-4 mt-8">
    <li
      v-for="(link, platform) in socialLinks"
      :key="platform"
      class="text-primary"
      :class="{ 'text-theme-link hover:text-theme-link-hover': isTemplate }"
      data-test="footer-social"
    >
      <a :href="link" :title="platform" :aria-label="`Open ${platform}`" rel="nofollow">
        <Icon :icon="socialIconMap[platform]" class="h-8 w-8" />
      </a>
    </li>
  </ul>
</template>
